import * as AccountNotifications from './AccountNotifications';
import * as LoadBoardHistory from './LoadBoardHistory';
import * as LoadBoardBid from './LoadBoardBid';
import configureStore from '../configureStore';

// The top-level state object
export interface ApplicationState {
    accountNotifications: AccountNotifications.AccountNotificationState;
    loadBoardHistory: LoadBoardHistory.LoadBoardHistoryState,
    loadBoardBid: LoadBoardBid.LoadBoardBidState
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers = {
  accountNotifications: AccountNotifications.reducer,
  loadBoardHistory: LoadBoardHistory.reducer,
  loadBoardBid: LoadBoardBid.reducer,
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export interface AppThunkAction<TAction> {
    (dispatch: (action: TAction) => void, getState: () => ApplicationState): void;
}

// Get the application-wide store instance
export const store = configureStore();
